<template>
    <div class="modaladmin">
        <div class="modaladmin-content">
            <div>
                EMAIL: 
                <input id="email" type="text" v-model="user.email" v-on:change="checkIfEmailExists()" />
                <div class="error" v-bind:style="{visibility: doesEmailExist && user.email !== originalEmail || !isEmailValid ? 'visible' : 'hidden'}">{{doesEmailExist ? 'Upisana e-mail adresa već postoji.' : 'Upisana e-mail adresa nije valjana.'}}</div>
            </div>
            <div>IME: <input type="text" v-model="user.firstName" /></div>
            <div>PREZIME: <input type="text" v-model="user.lastName" /></div>
            <div> 
                GODINA:
                <select id="birthyear" v-model="user.birthYear">
                    <option v-bind:value="null">-</option>
                    <option v-for="year in getYears()" v-bind:value="year" v-bind:key="year">
                        {{year}}
                    </option>
                </select> 
            </div>
            <div>
                ROLA:
                <select v-model="user.role">
                    <option v-for="role in roles" v-bind:value="role" v-bind:key="role">
                        {{role}}
                    </option>
                </select>
            </div>
            <div>
                TVRTKA:
                <select v-model="user.company">
                    <option v-bind:value="null">Nema</option>
                    <option v-for="company in companies" v-bind:value="company" v-bind:key="company.id">
                        {{company.name}}
                    </option>
                </select>
            </div>
            <div>TITULA: <input type="text" v-model="user.lecturerTitle" /></div>
            <div v-if="activateVisible">AKTIVAN: <input type="checkbox" v-model="user.isActivated"></div>
            <div>IMA SLIKU: <input type="checkbox" v-model="user.hasImage"></div>
            <div v-if="printVisible">ISPRINTAJ ODMAH: <input type="checkbox" v-model="printImmediately" v-on:change="savePrintPreference()"></div>
            <div class="modaladmin-footer">
                <button type="button" v-bind:disabled="!user.email || doesEmailExist && user.email !== originalEmail || !isEmailValid || !user.firstName || !user.lastName" v-on:click="$emit('save', user, printImmediately)">SPREMI</button>
                <button type="button" v-on:click="$emit('cancel', user)">ODUSTANI</button>
            </div>
        </div>
        <a aria-label="Zatvori popup" class="close-modaladmin" v-on:click="$emit('cancel', user)"></a>
    </div>
</template>

<script>
    import { emailRegex } from '@/config';

    export default {
        name: 'AddEditUserModal',
        data() {
            return {
                doesEmailExist: false,
                isEmailValid: true,
                originalEmail: "",
                activateVisible: true,
                printVisible: false,
                printImmediately: false
            }
        },
        props: {
            user: {},
            roles: Array,
            companies: Array
        },
        methods: {
            getYears: function() {
                let currentYear = new Date().getFullYear()
                let years = [];
                let startYear = 1950;

                while (startYear <= currentYear)
                    years.push(startYear++);

                return years.reverse();
            },
            checkIfEmailExists: function() {
                if(!this.user.email || !emailRegex.test(this.user.email))
                {
                    this.doesEmailExist = false;
                    this.isEmailValid = false;
                }
                else
                {
                    this.isEmailValid = true;
                    this.$axios.get(`${this.$API_URL}/user/check-email`, {
                        params: {
                            email: this.user.email
                        }
                    }).then(response => {
                        this.doesEmailExist = response.data;
                    });
                }
            },
            savePrintPreference: function() {
                localStorage.setItem('print', this.printImmediately);
            }
        },
        created() {
            if(!this.user.role)
                this.user.role = "Guest";

            if(!this.user.company)
                this.user.company = null;

            if(!this.user.birthYear)
                this.user.birthYear = null;

            if(this.user.email && this.user.email.length)
                this.originalEmail = this.user.email;

            if(!this.user.id)
            {
                this.printVisible = true;
                this.activateVisible = false;
            }

            let printImmediatelyStored = localStorage.getItem('print');

            if(printImmediatelyStored && !this.user.id)
                this.printImmediately = JSON.parse(printImmediatelyStored);
        }
    }
</script>